import {useEffect, useState} from 'react'
import {filled, blank} from '../../Helpers'
import {has, isArray, isString} from 'lodash'

export default function LaravelErrorOutput({name = null, submitErrors = null, nameOnly = true, className = ''}) {

    const [extraErrors, setExtraErrors] = useState([])

    useEffect(() => {

        if (blank(name) || blank(submitErrors)) {
            if (filled(extraErrors)) {
                setExtraErrors([])
            }
            return
        }

        if (!nameOnly) {
            if (isString(submitErrors)) {
                setExtraErrors([submitErrors])
                return
            }

            if (Array.isArray(submitErrors)) {
                const errors = []
                submitErrors.forEach((error) => {
                    if (typeof error === 'string') {
                        errors.push(error)
                    }
                    if (Array.isArray(error)) {
                        error.map(e => errors.push(e))
                    }
                })
                setExtraErrors(errors)
                return
            }
        }


        if (isArray(submitErrors)) {
            setExtraErrors(submitErrors)
            return
        }

        let foundErrors = null

        if (has(submitErrors, name)) {

            if (filled(submitErrors[name])) {
                foundErrors = submitErrors[name]
                if (isString(foundErrors)) {
                    setExtraErrors([foundErrors])
                    return
                }

                if (isArray(foundErrors)) {
                    setExtraErrors(foundErrors)
                    return
                }

            }
            setExtraErrors([])
            return
        }

        if (blank(submitErrors?.errors) || !has(submitErrors.errors, name) || blank(submitErrors.errors[name])) {
            setExtraErrors([])
            return
        }

        foundErrors = submitErrors.errors[name]

        if (isString(foundErrors)) {
            setExtraErrors([foundErrors])
            return
        }

        if (isArray(foundErrors)) {
            setExtraErrors(foundErrors)
            return
        }

        setExtraErrors([])
    }, [submitErrors])

    const classString = 'mt-2 text-sm text-red-600'

    return (
        <>
            {
                filled(extraErrors)
                &&
                <div className="mt-2 text-sm text-red-600">
                    {extraErrors.count > 1 ? (
                        <p className={classString}>
                            {extraErrors[0]}
                        </p>
                    ) : (
                        <ul>
                            {extraErrors.map((err, i) => (
                                <li key={i}>
                                    <span className={classString}>{err}</span>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            }
        </>
    )
}
